interface AdtractionProduct {
  programId: number;
  programName: string;

  sku: number;
  manufacturer: string;
  market: string;

  productName: string;
  productUrl: string;
  productDescription: string;
  productCategory: string;
  imageUrl: string;

  trackingUrl?: string;

  currency: string;
  productPrice: number;
  oldPrice: number;
  shipping: number;

  inStock: boolean;
  extraInfo: any[];
}

class Adtraction {
  CHANNEL_ID = 1525650295
  PROGRAM_ID = 1080727981

  cache: { [key: string]: [number, any] };

  constructor() {
    const rawCache = localStorage.getItem('_adtraction_cache')
    if (rawCache) {
      this.cache = JSON.parse(rawCache)
    } else {
      this.cache = {}
    }
  }

  persistCache () {
    localStorage.setItem('_adtraction_cache', JSON.stringify(this.cache))
  }

  isExpired (key: string): boolean {
    if (key in this.cache) {
      const cacheTime = this.cache[key][0]
      return cacheTime < (new Date().getTime() - 7*24*60*60*1000)
    } else {
      return true
    }
  }

  setInCache (key: string, value: any) {
    this.cache[key] = [new Date().getTime(), value]
  }
  getInCache (key: string): any {
    return this.cache[key][1]
  }

  async getTrackingLink(product: AdtractionProduct): Promise<AdtractionProduct> {
    const cacheKey = 'tracking-' + this.CHANNEL_ID + '-' + product.programId + '-' + product.sku
    if (this.isExpired(cacheKey)) {
      const resp = await fetch('https://api.adtraction.com/v2/public/tracking/link/', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          channelId: this.CHANNEL_ID,
          programId: product.programId,
          url: product.productUrl
        })
      })
      this.setInCache(cacheKey, await resp.json())
    }
    product.trackingUrl = this.getInCache(cacheKey).trackingUrl
    return product
  }

  async getProducts(model: string, withTracking: boolean): Promise<AdtractionProduct[]> {
    const cacheKey = 'products-' + this.CHANNEL_ID + '-' + model
    if (this.isExpired(cacheKey)) {
      const response = await fetch('https://api.adtraction.com/v2/public/products/', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'keyword': '*' + model + '*',
          'page': 0,
          'pageSize': 10,
          'channelId': this.CHANNEL_ID,
          'programId': this.PROGRAM_ID
        })
      })
      let json: AdtractionProduct[] = await response.json()
      json = json.filter(p => p.manufacturer === 'Ryobi' && p.productName.includes(model))
      this.setInCache(cacheKey, json)
    }
    let products: AdtractionProduct[] = this.getInCache(cacheKey)
    if (withTracking) {
      products = await Promise.all(products.map(this.getTrackingLink, this))
    }
    this.persistCache()
    return products
  }

  async preload(models: string[]) {
    const filteredModels = models
      .filter(m => this.isExpired('products-' + this.CHANNEL_ID + '-' + m), this)
    if (filteredModels.length === 0) {
      return
    }
    const keyword = filteredModels
      .map(m => '*' + m + '*')
      .reduce((prev, cur) => cur + (prev ? ' OR ' + prev : prev), '')
    let page = 0
    let items = []
    let count = -1
    do {
      const response = await fetch('https://api.adtraction.com/v2/public/products/', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'keyword': keyword,
          'page': page,
          'pageSize': 100,
          'channelId': this.CHANNEL_ID,
          'programId': this.PROGRAM_ID
        })
      })
      page += 1
      const countRaw = response.headers.get('count')
      if (countRaw) {
        count = Number.parseInt(countRaw)
      }
      items.push(...await response.json())
      console.warn(items.length, count)
    } while (items.length < count)
    items = items.filter(p => p.manufacturer === 'Ryobi')
    for (const model of filteredModels) {
      this.setInCache(
        'products-' + this.CHANNEL_ID + '-' + model,
        items.filter(p => p.productName.includes(model))
      )
    }

    this.persistCache()
  }

  async hasProduct(model: string): Promise<boolean> {
    return (await this.getProducts(model, false)).length > 0
  }
}

export default new Adtraction()